export default __webpack_public_path__ + "static/media/biogen-Logo.bb272867.png";